
import {
    ADD_PROSPECT_VEHICLE,
    ADD_PROSPECT_VEHICLE_SUCCESS,
    ADD_PROSPECT_VEHICLE_ERROR,
    UPDATE_PROSPECT_VEHICLE,
    UPDATE_PROSPECT_VEHICLE_SUCCESS,
    UPDATE_PROSPECT_VEHICLE_ERROR,
    DELETE_PROSPECT_VEHICLE,
    DELETE_PROSPECT_VEHICLE_SUCCESS,
    DELETE_PROSPECT_VEHICLE_ERROR,

} from "./actionTypes";

// addLeadVehicle
export const addProspectVehicle = payload => {
    return {
        type: ADD_PROSPECT_VEHICLE,
        payload: payload,
    }
}

// addLeadVehicleSuccess
export const addProspectVehicleSuccess = prospect => {
    return {
        type: ADD_PROSPECT_VEHICLE_SUCCESS,
        payload: prospect,
    }
}

// addLeadVehicleError
export const addProspectVehicleError = error => {
    return {
        type: ADD_PROSPECT_VEHICLE_ERROR,
        payload: error,
    }
}

// updateLeadVehicle
export const updateProspectVehicle = payload => {
    return {
        type: UPDATE_PROSPECT_VEHICLE,
        payload: payload,
    }
}

// updateLeadVehicleSuccess
export const updateProspectVehicleSuccess = prospect => {
    return {
        type: UPDATE_PROSPECT_VEHICLE_SUCCESS,
        payload: prospect,
    }
}

// updateLeadVehicleError
export const updateProspectVehicleError = error => {
    return {
        type: UPDATE_PROSPECT_VEHICLE_ERROR,
        payload: error,
    }
}

// deleteLeadVehicle
export const deleteProspectVehicle = payload => {
    return {
        type: DELETE_PROSPECT_VEHICLE,
        payload: payload,
    }
}

// deleteLeadVehicleSuccess
export const deleteProspectVehicleSuccess = prospect => {
    return {
        type: DELETE_PROSPECT_VEHICLE_SUCCESS,
        payload: prospect,
    }
}

// deleteLeadVehicleError
export const deleteProspectVehicleError = error => {
    return {
        type: DELETE_PROSPECT_VEHICLE_ERROR,
        payload: error,
    }
}